import { cancelTask, resynthesis } from '~/api'
import { useConfirm } from '~/hooks/useModal/modals/confirm'

const COPYWRITING_MAP = () => {
  const { $t } = useNuxtApp()
  return {
    [COLLECTION_MAP.OPUS]: {
      title: $t('qu-xiao-xuan-ran'),
      description: $t(
        'gai-zuo-pin-zheng-zai-xuan-ran-zhong-ru-guo-qu-xiao-ze-jiang-diu-shi-yi-xuan-ran-de-jin-du-shi-fou-guan-bi-gai-ren-wu'
      ),
      okText: $t('qu-xiao-xuan-ran'),
      successText: $t('qu-xiao-cheng-gong'),
      errorText: $t('qu-xiao-shi-bai'),
    },
    [COLLECTION_MAP.PIECES]: {
      title: $t('guan-bi-he-cheng'),
      description: $t(
        'gai-cheng-pian-zheng-zai-he-cheng-zhong-ru-guo-guan-bi-ze-jiang-diu-shi-yi-he-cheng-de-jin-du-shi-fou-guan-bi-gai-ren-wu'
      ),
      okText: $t('guan-bi-he-cheng'),
      successText: $t('guan-bi-cheng-gong'),
      errorText: $t('guan-bi-shi-bai'),
    },
  }
}

const cancelRenderTask = async (id: number, callback?: () => void) => {
  const copyWritingMap = COPYWRITING_MAP()

  const response: any = await cancelTask({ ids: [id] }) // 作品用generate_record_task_id，成片用id
  if (response.code === 0) {
    message.success(copyWritingMap[COLLECTION_MAP.OPUS].successText)
    callback?.()
  } else {
    message.error(copyWritingMap[COLLECTION_MAP.OPUS].errorText)
  }
}

// 取消合成或渲染
export const handleCancelTask = (record: any, callback?: () => void) => {
  const copyWritingMap = COPYWRITING_MAP()
  const id = record?.generate_record_task_id ?? record?.model_id ?? record?.id
  if (id) {
    if (
      [
        EXECUTION_STATUS.NOT_STARTED,
        EXECUTION_STATUS.DATA_INIT,
        EXECUTION_STATUS.WAITING,
      ].includes(record.status)
    ) {
      cancelRenderTask(id, callback)
    } else {
      useConfirm({
        icon: true,
        title: copyWritingMap[COLLECTION_MAP.OPUS].title,
        description: copyWritingMap[COLLECTION_MAP.OPUS].description,
        okButtonProps: {
          danger: true,
        },
        okText: copyWritingMap[COLLECTION_MAP.OPUS].okText,
        onOk: () => {
          cancelRenderTask(id, callback)
        },
      })
    }
  }
}

// 关闭作品
export const handleCloseTask = async (record: any, callback?: () => void) => {
  const { $t } = useNuxtApp()
  const response: any = await cancelTask({
    ids: [record?.generate_record_task_id ?? record.id],
  })
  if (response.code === 0) {
    message.success($t('guan-bi-cheng-gong'))
    callback?.()
  } else {
    message.error($t('guan-bi-shi-bai'))
  }
}

export const handleRetry = async (record: any, callback?: () => void) => {
  const { $t } = useNuxtApp()
  const id = record?.generate_record_task_id ?? record.id
  if (id) {
    try {
      const response: any = await resynthesis({ id })
      if (response.code === 0) {
        message.success($t('cao-zuo-cheng-gong'))
        callback?.()
      }
    } catch (error) {
      console.error(error)
    }
  }
}

export { COPYWRITING_MAP }
